import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import textWeight from "../../utils/textWeight";
export default (userData, type, name) => {
  const [value, setValue] = useState("");
  const { TextWeight } = textWeight();
  const [isPasswordVisible, setIsPasswordVisible] = useState(false);
  const navigate = useNavigate();
  const togglePasswordVisibility = () => {
    setIsPasswordVisible(!isPasswordVisible);
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`; // format yyyy-mm-dd
  };

  useEffect(() => {
    if (name === "full_name") {
      const fullName = `${
        (userData?.first_name || "") + " " + (userData?.last_name || "")
      }`.trim();
      setValue(fullName);
    } else if (type === "date" && userData?.[name]) {
      setValue(formatDate(userData?.[name]));
    } else if (userData?.[name]) {
      setValue(userData?.[name]);
    }
  }, [userData, name, type]);

  const inputRef = useRef(null);

  const handleFocusInput = () => {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  };
  return {
    TextWeight,
    value,
    setValue,
    isPasswordVisible,
    inputRef,
    handleFocusInput,
    togglePasswordVisibility,
    navigate,
  };
};
